export default __webpack_public_path__ + "static/media/nicks-club-blur.2849d43c.jpg";